/* global L */

import { isIframe, isMinWidthDesktop } from './utils';

class MapInitService {
  constructor() {
    if (typeof window !== 'undefined') {
      this.L = require('leaflet');
    }

    this.MAX_ZOOM = 17;
  }

  initMap() {
    let mymap;

    if (isMinWidthDesktop()) {
      mymap = this.L.map('mapid', { zoomControl: false, maxZoom: this.MAX_ZOOM, zoomSnap: 0, zoomDelta: 0.3 }).setView([50.5, 8.0], 6.3);
    } else if (isIframe()) {
      mymap = this.L.map('mapid', { zoomControl: false, maxZoom: this.MAX_ZOOM, tap: false, dragging: true }).setView([49.0, 10.0], 5);
    } else {
      mymap = this.L.map('mapid', { zoomControl: false, maxZoom: this.MAX_ZOOM, tap: false, dragging: false }).setView([49.0, 10.0], 5);
    }

    L.control.zoom({ zoomInText: '', zoomOutText: '', position: 'topright' }).addTo(mymap);

    // Trusted domain for PRODUCTION is "energieatlas.eon.de" & trusted domains for DEVELOPMENT are "dev.eon-ea.diva-e.com" & "localhost".
    const apiKey = process.env.GATSBY_PRODUCTION ? 'y0M9U1VOmedWJVaVAIwdKHpjQR3l04D5P1Ys9e0_AtI' : 'aHn2AnMtSorqLFLs3lu50RqyTBg7AHghf8fi0Lc9T84';
    const hereTileUrl = `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=lite.day&features=pois:disabled,public_transit:disabled&lang=de&ppi=400&size=512&apiKey=${apiKey}`;
    const CartoDB_PositronNoLabels = this.L.tileLayer(hereTileUrl, {
      attribution: `Map Tiles &copy; ${new Date().getFullYear()} <a href="http://developer.here.com">HERE</a>`,
      subdomains: 'abcd',
      minZoom: 5,
      maxZoom: this.MAX_ZOOM,
      opacity: 0.5
    });

    CartoDB_PositronNoLabels.addTo(mymap);

    return mymap;
  }
}

export default MapInitService;